import HttpService from '@/api/HttpService';
import UserProfile from '@/entities/userProfile';
import { settingsApp } from '@/config/config';
import { retryFn } from '@/util';

import {
  SET_ACCOUNT_STATUS,
  SET_ACTIVE_ACCOUNT_ID,
  SET_IR_ADMIN_ROLE,
  SET_STATIC_INFORMATION,
  SET_USER,
  SET_MAINTENANCE,
  SET_LOADING_REDIRECTION,
} from '../mutation-types';


export default {
  namespaced: true,
  state: {
    geoLocation: {},
    reservedImpactPreferenceCodes: {},
    accountStatus: '',
    accountTypes: {},
    activeAccountId: null,
    activeAccount: {},
    communicationPreferences: {},
    fundingSourceTypes: {},
    institutionTypes: {},
    investmentsRestrictions: {},
    irAdmin: false,
    loggedUser: {},
    paymentPreferences: {},
    restrictedStates: {},
    transactionStatus: {},
    transactionTypes: {},
    trustTypes: {},
    upcomingTransactionActions: {},
    user: {},
    userTypes: {},
    userCommentCategories: {},
    maintenance: false,
    loadingRedirection: false,
    hasBeenDisabledSignUp: settingsApp.hasBeenDisablledSignUp || 'OFF',
  },
  getters: {
    hasBeenCreatedAccount: state =>
      state.user && state.user.accounts && !!state.user.accounts.length,
    hasBeenRedirected: state => state.loadingRedirection,
  },
  mutations: {
    [SET_USER](state, user) {
      if (Object.keys(user).length === 0) {
        state.user = Object.assign({}, new UserProfile());
        return;
      }
      state.user = { ...user };
      state.irAdmin = user.roles.includes('IR_ADMIN');
    },
    [SET_ACCOUNT_STATUS](state, status) {
      state.accountStatus = status;
    },
    [SET_IR_ADMIN_ROLE](state, isAdmin = false) {
      state.irAdmin = isAdmin;
    },
    [SET_STATIC_INFORMATION](state, staticInformation) {
      state = Object.assign(state, staticInformation); // eslint-disable-line no-param-reassign
    },
    [SET_ACTIVE_ACCOUNT_ID](state, account) {
      // Nothing to restore (e.g. sessionStorage has no active account yet).
      // Bailing out keeps the previous state instead of throwing half way
      // through and leaving activeAccount empty.
      if (!account) {
        return;
      }
      const data = {
        id: account.id,
        accountName: account.accountName,
        accountType: account.accountType,
        primaryInvestorId: account.primaryInvestorId,
        paymentPreference: account.paymentPreference,
        interestPreference: account.interestPreference,
      };
      sessionStorage.setItem('activeAccount', JSON.stringify(data));
      state.activeAccountId = account.id;
      state.activeAccount = account;
    },
    [SET_MAINTENANCE](state) {
      state.maintenance = true;
    },
    [SET_LOADING_REDIRECTION](state) {
      state.loadingRedirection = true;
    },
  },
  actions: {
    async getStaticInformation({ commit }) {
      try {
        const staticInformation = await retryFn(() => HttpService.getV2('static-information'), 3, 1000);

        commit(
          SET_STATIC_INFORMATION,
          {
            ...staticInformation,
            userCommentCategories: (staticInformation.userCommentCategories || []).map(
              d => ({ id: d.id, name: d.name }),
            ),
          },
        );
        if (settingsApp.showMaintenance === 'true') {
          commit(SET_MAINTENANCE);
        }
      } catch (error) {
        commit(SET_MAINTENANCE);
      }
    },
    getRateAndTermByGroup({ commit }, { manageRateAndTermGroupsId }) {
      return HttpService.getV2(`/rate-and-term-groups/${manageRateAndTermGroupsId}`);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js